var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide-out" } }, [
    _vm.slideOutOpen
      ? _c("div", { staticClass: "viq-slideout" }, [
          _c("div", {
            staticClass: "viq-slideout__overlay",
            on: { click: _vm.close },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "viq-slideout__panel" }, [
            _c("div", { staticClass: "viq-slideout__header" }, [
              _c("h3", { staticClass: "viq-slideout__title" }, [
                _vm._v("Source Article"),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "viq-slideout__close",
                  on: { click: _vm.close },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M4 4l8 8M12 4l-8 8",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "viq-slideout__body" },
              [
                _vm.loading
                  ? _c(
                      "div",
                      { staticClass: "viq-slideout__loading" },
                      _vm._l(8, function (i) {
                        return _c("div", {
                          key: i,
                          staticClass: "viq-slideout__skeleton",
                        })
                      }),
                      0
                    )
                  : _vm.slideOutArticle
                  ? _c("ViqArticleDetail", {
                      attrs: { article: _vm.slideOutArticle },
                    })
                  : _c("div", { staticClass: "viq-slideout__empty" }, [
                      _vm._v("\n          No article selected\n        "),
                    ]),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }